import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { ToolbarModule } from '@components/toolbar';
import { AddressFormModule } from '@shared/address-form/address-form.module';
import { LoadingModule } from '@components/loading';
import { InputModule } from '@components/inputs';
import { PopUpModalModule } from '@components/pop-up-modal';
import { PopUpModule } from '@components/pop-up';
import { CsIconModule } from '@components/icon';
import { RouterModule } from '@angular/router';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { UserAddressListComponent } from './user-address-list/user-address-list.component';
import { UserAddressEditComponent } from './user-address-edit/user-address-edit.component';
import { UserAddressBottomsheetModule } from './user-address-bottomsheet/user-address-bottomsheet.module';
import { ShiprocketAddressBannerComponent } from './shiprocket-address-banner/shiprocket-address-banner.component';
import { authenticationGuard } from '../guards/authentication.guard';
import { onboardingGuard } from '../guards/onboarding.guard';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { ExpectedDeliveryDateComponent } from '@shared/expected-delivery-date/expected-delivery-date.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'address',
        canActivate: [authenticationGuard, onboardingGuard],
        children: [
          { path: '', component: UserAddressListComponent },
          { path: ':id/edit', component: UserAddressEditComponent },
          { path: 'new', component: UserAddressEditComponent },
        ],
      },
    ]),
    CsIconModule,
    ButtonModule,
    ToolbarModule,
    AddressFormModule,
    LoadingModule,
    InputModule,
    PopUpModalModule,
    PopUpModule,
    ButtonCtaComponent,
    ExpectedDeliveryDateComponent,
    MatBottomSheetModule,
    UserAddressBottomsheetModule,
  ],
  declarations: [
    UserAddressListComponent,
    UserAddressEditComponent,
    ShiprocketAddressBannerComponent,
  ],
})
export class UserAddressModule { }
